import { render, staticRenderFns } from "./DistributeDifferentContributionsAmongLinkedGoalsPocket.vue?vue&type=template&id=55a69ab0&scoped=true&"
import script from "./DistributeDifferentContributionsAmongLinkedGoalsPocket.vue?vue&type=script&lang=ts&"
export * from "./DistributeDifferentContributionsAmongLinkedGoalsPocket.vue?vue&type=script&lang=ts&"
import style0 from "./DistributeDifferentContributionsAmongLinkedGoalsPocket.vue?vue&type=style&index=0&id=55a69ab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a69ab0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VDialog,VIcon,VImg,VRow,VTextField})
